module.exports = __webpack_public_path__ + "img/nube3.7bc87316.svg";